import { faGlobe } from '@fortawesome/pro-regular-svg-icons'
import { faCaretDown, faCheck } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import classNames from 'classnames'
import { Link } from 'gatsby'
import { FormattedMessage, useIntl } from 'react-intl'
import { useLocalizedPath } from '../../../../i18n/useLocalizedPath'
import { STORE, redirectTo, usePreferredLanguagesSettingStore } from '../../../../i18n/usePreferredLanguagesSetting'
import * as SiteWideStyles from '../../../styles/abstract/SiteWide.css'
import * as FooterBottomStyles from '../../../styles/foundation/FooterBottom.css'
import { formattedMessageValues } from '../../../utils/FormattedMessageValues'
import { getFooterMenu } from '../get-footer-menu'

export const FooterBottom = () => {
  const show = useLocalizedPath()
  const { messages } = useIntl()
  const { preferredLanguage, setJapanese, setEnglish } = usePreferredLanguagesSettingStore()

  return (
    <div className={FooterBottomStyles.Container} data-classname="FooterBottom-Container">
      <nav className={SiteWideStyles.Inner} data-classname="FooterBottom-Inner">
        <div className={FooterBottomStyles.Content}>
          <ul className={FooterBottomStyles.Navigation} data-classname="FooterBottom-Navigation">
            {getFooterMenu(preferredLanguage).map((item, index) => (
              <li key={`footer-bottom-${index}`}>
                <Link {...getFooterLinkProps(item, index, messages)}>
                  <FormattedMessage
                    id={`components.foundation.footer.bottom.nav.text${index + 1}`}
                    defaultMessage={item.name}
                    values={{ ...formattedMessageValues }}
                  />
                </Link>
              </li>
            ))}
          </ul>
          {show && (
            <div className={FooterBottomStyles.LanguageMenu}>
              <button type="button" className={FooterBottomStyles.LanguageMenu_Button}>
                <FontAwesomeIcon
                  icon={faGlobe}
                  className={classNames(FooterBottomStyles.LanguageMenu_Icon, 'LanguageMenu_Icon-globe')}
                />
                <span className={FooterBottomStyles.LanguageMenu_Text}>
                  {preferredLanguage === STORE.PREFFERRED_LANGUAGE.JAPANESE ? '日本語' : 'English'}
                </span>
                <FontAwesomeIcon
                  icon={faCaretDown}
                  className={classNames(FooterBottomStyles.LanguageMenu_Icon, 'LanguageMenu_Icon-caretDown')}
                />
              </button>
              <ul className={FooterBottomStyles.LanguageCatalog}>
                <li>
                  <button
                    type="button"
                    className={FooterBottomStyles.LanguageCatalog_Item}
                    onClick={() => {
                      setJapanese()
                      redirectTo(STORE.PREFFERRED_LANGUAGE.JAPANESE)
                    }}
                  >
                    <FontAwesomeIcon
                      icon={faCheck}
                      className={classNames(
                        FooterBottomStyles.Language_Icon,
                        preferredLanguage === STORE.PREFFERRED_LANGUAGE.JAPANESE ? 'Language_Icon-show' : ''
                      )}
                    />
                    日本語
                  </button>
                </li>
                <li>
                  <button
                    type="button"
                    className={FooterBottomStyles.LanguageCatalog_Item}
                    onClick={() => {
                      setEnglish()
                      redirectTo(STORE.PREFFERRED_LANGUAGE.ENGLISH)
                    }}
                  >
                    <FontAwesomeIcon
                      icon={faCheck}
                      className={classNames(
                        FooterBottomStyles.Language_Icon,
                        preferredLanguage === STORE.PREFFERRED_LANGUAGE.ENGLISH ? 'Language_Icon-show' : ''
                      )}
                    />
                    English
                  </button>
                </li>
              </ul>
            </div>
          )}
        </div>
        <small className={FooterBottomStyles.Copyright} data-classname="FooterBottom-Copyright">
          <FormattedMessage
            id="components.foundation.footer.bottom.copyright"
            defaultMessage="©PLAID Inc. all rights reserved."
            values={{ ...formattedMessageValues }}
          />
        </small>
      </nav>
    </div>
  )
}

const getFooterLinkProps = (
  item: ReturnType<typeof getFooterMenu>[number],
  index: number,
  messages: Record<string, any>
) =>
  ({
    className: classNames(FooterBottomStyles.LinkText, ['trackBtn']),
    'data-classname': 'FooterBottom-LinkText',
    to: item.link,
    'data-category': 'footer',
    'data-action': 'term',
    'data-label':
      messages && typeof messages[`components.foundation.footer.bottom.nav.text${index + 1}`] === 'string'
        ? messages[`components.foundation.footer.bottom.nav.text${index + 1}`]
        : item.name,

    // Add security attributes for external links
    ...(item.blank && {
      target: '_blank',
      rel: 'noopener',
    }),
  }) as const
